module.exports = __webpack_public_path__ + "img/kachel_ALOEVERATRINKGELFREEDOM.b85dc02c.png";